import { useTranslation } from "react-i18next";
import { Button } from "react-aria-components";
import { css } from "../../../../styled-system/css";
import TEMPLATES from "./templates";
import { useProgramContext } from "./ProgramContext";

const gridStyles = css({
  display: "grid",
  gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
  gap: "medium",
});

const tileStyles = css({
  display: "flex",
  flexDirection: "column",
  gap: "xsmall",
  padding: "medium",
  border: "1px solid",
  borderColor: "border.default",
  borderRadius: "standard",
  backgroundColor: "white",
  color: "inherit",
  fontSize: "medium",
  textAlign: "start",
  cursor: "pointer",
  outline: "none",
  _hover: { borderColor: "fuchsia" },
  _focusVisible: { outline: "2px solid", outlineColor: "fuchsia" },
});

const SelectTemplate = ({ isStaff, onSelect }) => {
  const { t } = useTranslation(["programs"]);
  const { engine } = useProgramContext();

  return (
    <>
      <p>{t(($) => $.programs["Select A Template or Create custom rules"])}</p>
      <div className={gridStyles}>
        {TEMPLATES.filter((template) => template.engine === engine && ((template.enabled ?? true) || isStaff)).map(
          (template) => (
            <Button key={template.id} className={tileStyles} onPress={() => onSelect(template.id)}>
              <span className={css({ fontWeight: "600" })}>{t(template.name)}</span>
              <span className={css({ fontSize: "small", color: "text.secondary" })}>{t(template.description)}</span>
            </Button>
          ),
        )}
      </div>
    </>
  );
};

export default SelectTemplate;
